import client from '../clients/client';
import {
  FixWebhooksResult, ShopifyDetailsResponse, ShopifyGraphqlResult, ShopifyJob, ShopifyJobsResponse, ShopifyWebhook,
} from '../models/shopify';

const base = (shopId: string) => `/shopify/${encodeURIComponent(shopId)}`;

export const getShopifyDetails = async (shopId: string): Promise<ShopifyDetailsResponse> => {
  const response = await client.get<ShopifyDetailsResponse>(base(shopId));
  return response.data;
};

export const createShopifyWebhook = async (shopId: string, topic: string, uri: string): Promise<ShopifyWebhook> => {
  const response = await client.post<ShopifyWebhook>(`${base(shopId)}/webhooks`, { topic, uri });
  return response.data;
};

// Webhook ids are GraphQL gids (gid://shopify/WebhookSubscription/123); the API takes the number.
const webhookPath = (shopId: string, webhookId: string) =>
  `${base(shopId)}/webhooks/${encodeURIComponent(webhookId.split('/').pop() ?? '')}`;

export const updateShopifyWebhook = async (shopId: string, webhookId: string, uri: string): Promise<ShopifyWebhook> => {
  const response = await client.patch<ShopifyWebhook>(webhookPath(shopId, webhookId), { uri });
  return response.data;
};

export const deleteShopifyWebhook = async (shopId: string, webhookId: string): Promise<void> => {
  await client.delete(webhookPath(shopId, webhookId));
};

export const fixShopifyWebhooks = async (shopId: string): Promise<FixWebhooksResult> => {
  const response = await client.post<FixWebhooksResult>(`${base(shopId)}/webhooks/fix`);
  return response.data;
};

export const runShopifyGraphql = async (
  shopId: string, query: string, variables: Record<string, unknown> | null,
): Promise<ShopifyGraphqlResult> => {
  const response = await client.post<ShopifyGraphqlResult>(`${base(shopId)}/graphql`, { query, variables });
  return response.data;
};

export const getShopifyJobs = async (shopId: string): Promise<ShopifyJobsResponse> => {
  const response = await client.get<ShopifyJobsResponse>(`${base(shopId)}/jobs`);
  return response.data;
};

// Sets the job's status (not its type) to DONE.
export const markShopifyJobDone = async (shopId: string, jobId: number): Promise<ShopifyJob> => {
  const response = await client.post<ShopifyJob>(`${base(shopId)}/jobs/${jobId}/done`);
  return response.data;
};

export const deleteShopifyJob = async (shopId: string, jobId: number): Promise<void> => {
  await client.delete(`${base(shopId)}/jobs/${jobId}`);
};
